/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import SelectBranch from "./SelectBranch.jsx";
import SelectClass from "./SelectClass.jsx";
import SelectSection from "./SelectSection.jsx";
import { hitApi } from "../utils/apiCall.js";
import { Link, useNavigate } from "react-router-dom";
import accessDenied from "../pages/assets/accessDenied.png";

const mId = 13;
const sId = 1; // Student Attendance ID

function AttendanceForm() {
  const navigate = useNavigate()
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [branchKeys, setBranchKeys] = useState([]);
  const [classKeys, setClassKeys] = useState([]);
  const [sectionKeys, setSectionKeys] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [branchFromComp, setBranchfromComp] = useState([]);
  const [classFromComp, setClassfromComp] = useState([]);
  const [sectionFromComp, setSectionfromComp] = useState([]);
  const [access, setAccess] = useState({});
  const [loadingAccess, setLoadingAccess] = useState(true);


useEffect(() => {
  async function getAccessDetails() {
    setLoadingAccess(true); // Start loading
    const fd = new FormData();
    fd.append("subMenu", sId);
    fd.append("menuId", mId);
    const res = await hitApi("permission/permission", "getAccessDetails", fd);
    if (res.success) {
      setAccess(res.data[0]);
    } else {
      setAccess({});
    }
    setLoadingAccess(false); // Stop loading
  }
  getAccessDetails();
}, []);

  const steps = [
    <SelectBranch setBranchfromComp={setBranchfromComp} key="branch" />,
    <SelectClass setClassfromComp={setClassfromComp} key="class" />,
    <SelectSection setSectionfromComp={setSectionfromComp} key="section" />,
  ];

  const [stepValidations, setStepValidations] = useState([false, false, false]);

  useEffect(() => {
    const validateSelections = () => {
      const storedBranch = JSON.parse(localStorage.getItem("branch")) || {};
      const storedClass = JSON.parse(localStorage.getItem("class")) || {};
      const storedSection = JSON.parse(localStorage.getItem("section")) || {};

      const selectedBranches = Object.keys(storedBranch).filter(
        (key) => storedBranch[key]
      );
      const selectedClasses = Object.keys(storedClass).filter(
        (key) => storedClass[key]
      );
      const selectedSections = Object.keys(storedSection).filter(
        (key) => storedSection[key]
      );

      setBranchKeys(selectedBranches);
      setClassKeys(selectedClasses);
      setSectionKeys(selectedSections);

      setIsFormValid(
        selectedBranches.length > 0 &&
          selectedClasses.length > 0 &&
          selectedSections.length > 0
      );
    };

    validateSelections();
  }, []);

  // forStep Validation
  useEffect(() => {
    const storedBranch = branchFromComp || {};
    const storedClass = classFromComp || {};
    const storedSection = sectionFromComp || {};

    const selectedBranches = Object.keys(storedBranch).filter(
      (key) => storedBranch[key]
    );
    const selectedClasses = Object.keys(storedClass).filter(
      (key) => storedClass[key]
    );
    const selectedSections = Object.keys(storedSection).filter(
      (key) => storedSection[key]
    );

    // Update step validation
    setStepValidations([
      selectedBranches.length > 0, // Step 1 (Branch)
      selectedClasses.length > 0, // Step 2 (Class)
      selectedSections.length > 0, // Step 3 (Section)
    ]);

    // Form is valid when all steps have selections
    setIsFormValid(
      selectedBranches.length > 0 &&
        selectedClasses.length > 0 &&
        selectedSections.length > 0
    );
  }, [branchFromComp, classFromComp, sectionFromComp]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("branch", JSON.stringify(branchKeys));
    formData.append("class", JSON.stringify(classKeys));
    formData.append("section", JSON.stringify(sectionKeys));

    const res = await hitApi("your/api/endpoint", "POST", formData);

    if (res.success) {
      console.log("Form submitted successfully", res);
    } else {
      console.log("Error in form submission", res);
    }
  };

  function next() {
    if (currentStepIndex < steps.length - 1) {
      setCurrentStepIndex((i) => i + 1);
    }
  }

  function back() {
    if (currentStepIndex > 0) {
      setCurrentStepIndex((i) => i - 1);
    }
  }

  const currentStep = steps[currentStepIndex];

  return (
    <>
      {loadingAccess ? (
      // Show loader while fetching access
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    ) : access?.is_view === "1" ? (
      // Your existing form JSX here
        <div className="page-content-wrapper" style={{marginTop:"0"}}>

              {/* Header with back button */}
          <div className="d-flex align-items-center px-3  bg-white border-bottom  p-2">
            <button
              className="btn btn-link text-primary p-2 me-2"
              onClick={() => navigate(-1)}
              style={{ fontSize: "20px" }}
            >
              <i className="bi bi-arrow-left"></i>
            </button>
            <h6 className="m-0">Select Branch, Class, Section</h6>
          </div>
          <div className="container " style={{ marginTop: "2rem" }}>
            {currentStep}
          </div>


         
          <div
            style={{ bottom: "0%" }}
            className="position-fixed py-2 bg-white w-100 g-0 row"
          >
            <div className="col-6 text-center">
              {currentStepIndex > 0 && (
                <button
                  onClick={back}
                  className="btn btn-primary"
                  style={{ width: "95%" }}
                >
                  Prev
                </button>
              )}
            </div>

            <div className="col-6 text-center">
              {currentStepIndex < steps.length - 1 ? (
                <button
                  onClick={next}
                  className="btn btn-primary"
                  style={{ width: "95%" }}
                  disabled={!stepValidations[currentStepIndex]} // Ensure current step is valid before proceeding
                >
                  Next
                </button>
              ) : stepValidations.every((valid) => valid) ? ( // Check if all steps are valid
                <Link
                  style={{ width: "95%" }}
                  to="/attendance"
                  // onClick={handleSubmit}
                  className="btn btn-primary"
                >
                  Proceed
                </Link>
              ) : (
                <button
                  style={{ width: "95%" }}
                  className="btn btn-secondary"
                  disabled
                >
                  Select all fields
                </button>
              )}
            </div>
          </div>
        </div>
      ) : (
      // Show No Access screen
      <div className="page-content-wrapper">
        <div className="container p-1" style={{ marginTop: "2rem" }}>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <img src={accessDenied} alt="" />
            <br />
            <h1>No access</h1>
          </div>
        </div>
      </div>
    )}
  </>
  );
}

export default AttendanceForm;
